import {
  SupplierUserGroup, Permission, type UserSession 
} from '@/types/auth';

const GROUP_PERMISSIONS: Record<string, Permission[]> = {
  [SupplierUserGroup.SUPPLIER_ADMIN]: [
    Permission.VIEW_SOURCING_EVENTS,
    Permission.SUBMIT_BIDS,
    Permission.VIEW_SUPPLIER_ORDERS,
    Permission.UPDATE_DELIVERY,
    Permission.MANAGE_SUPPLIER_PROFILE,
  ],
  [SupplierUserGroup.SUPPLIER_SALES]: [
    Permission.VIEW_SOURCING_EVENTS,
    Permission.SUBMIT_BIDS,
    Permission.VIEW_SUPPLIER_ORDERS,
  ],
  [SupplierUserGroup.SUPPLIER_DELIVERY]: [
    Permission.VIEW_SUPPLIER_ORDERS,
    Permission.UPDATE_DELIVERY,
  ],
};

export function hasPermission(user: UserSession, permission: Permission): boolean {
  return getUserPermissions(user).includes(permission);
}

export function hasAnyPermission(user: UserSession, permissions: Permission[]): boolean {
  return permissions.some((p) => hasPermission(user, p));
}

export function getUserPermissions(user: UserSession): Permission[] {
  const permissions = new Set<Permission>();
  for (const group of user.groups) {
    const groupPerms = GROUP_PERMISSIONS[group];
    if (groupPerms) {
      groupPerms.forEach((p) => permissions.add(p));
    }
  }
  return Array.from(permissions);
}

export function getPrimaryGroup(user: UserSession): string {
  const priority = Object.values(SupplierUserGroup);
  for (const group of priority) {
    if (user.groups.includes(group)) return group;
  }
  return user.groups[0] ?? 'unknown';
}
